import { useMemo } from 'react';
import { useGetCompTeamResultsBySessionQuery } from '../state/api';
import TeamSessionResults from './team-session-results';
import { lookupMemberName } from '../utils/members';
import { useTeamCompetitionData } from '../hooks/useTeamCompetitionData';

interface TeamSessionResultsContainerProps {
  comp_id: string | null | undefined;
}

const TeamSessionResultsContainer = ({ comp_id }: TeamSessionResultsContainerProps) => {
  const { competitions, members } = useTeamCompetitionData();
  const { data: sessionResultsData = [] } = useGetCompTeamResultsBySessionQuery(comp_id!, {
    skip: comp_id == null,
  });

  const { teamWinner, sessionResults, teamACaptainID, teamACaptainName, teamBCaptainID, teamBCaptainName } =
    useMemo(() => {
      const teamCompetition = competitions[comp_id!];

      const captains = () => {
        if (!teamCompetition || !members || !members.length) {
          return {
            teamACaptainID: undefined,
            teamACaptainName: undefined,
            teamBCaptainID: undefined,
            teamBCaptainName: undefined,
          };
        }

        return {
          teamACaptainID: teamCompetition.teamACaptainID,
          teamACaptainName: teamCompetition.teamACaptainID
            ? lookupMemberName(members, teamCompetition.teamACaptainID)
            : undefined,
          teamBCaptainID: teamCompetition.teamBCaptainID,
          teamBCaptainName: teamCompetition.teamBCaptainID
            ? lookupMemberName(members, teamCompetition.teamBCaptainID)
            : undefined,
        };
      };

      return {
        teamWinner: teamCompetition ? teamCompetition.winner : undefined,
        sessionResults: sessionResultsData,
        ...captains(),
      };
    }, [competitions, sessionResultsData, members, comp_id]);

  return (
    <TeamSessionResults
      teamWinner={teamWinner}
      sessionResults={sessionResults}
      teamACaptainID={teamACaptainID}
      teamACaptainName={teamACaptainName}
      teamBCaptainID={teamBCaptainID}
      teamBCaptainName={teamBCaptainName}
    />
  );
};

export default TeamSessionResultsContainer;
